import {request} from '@/services/solid-api-service';

export interface QuestionSummary {
    orderId: number;
    minutes: number;
}

export interface ChallengeSummary {
    firstName: string;
    lastName: string;
    emailAddress: string;
    name: string;
    totalMinutes: number;
    questionSummaries: QuestionSummary[];
    token: string;
}

export interface CompileAndTestResult {
    consoleOutput: string;
    results: UnitTestResult[];
}

export interface UnitTestResult {
    name: string;
    passed: boolean;
    message: string;
}

export interface Question {
    name: string;
    number: number;
    problemDescription: string;
    templateCode: string;
    minutes: number;
    timer: number;
    complete: boolean;
}

export interface BreakTime {
    onBreak: boolean;
    timer: number;
}

export interface ChallengeResultSummary {
    name: string;
    complete: boolean;
    result: boolean;
    displayTime: string;
    displayScore: string;
    displayResult: string;
    feedbackSubmitted: boolean;
    feedback: string;
    lines: ChallengeResultSummaryLine[];
}

export interface ChallengeResultSummaryLine {
    name: string;
    displayTime: string;
    displayScore: string;
}

export async function validateChallengeKey(challengeKey: string): Promise<string> {
    return request<string>('ValidateChallengeKey', {
        challengeKey,
    });
}

export async function submitParticipant(firstName: string, lastName: string, emailAddress: string, challengeKey: string): Promise<ChallengeSummary> {
    return request<ChallengeSummary>('SubmitParticipant', {
        firstName,
        lastName,
        emailAddress,
        challengeKey,
    });
}

export async function checkBreak(): Promise<BreakTime> {
    return request<BreakTime>('CheckBreak');
}

export async function checkComplete(): Promise<ChallengeResultSummary> {
    return request<ChallengeResultSummary>('CheckComplete');
}

export async function endBreak(): Promise<void> {
    return request<void>('EndBreak');
}

export async function startBreak(): Promise<void> {
    return request<void>('StartBreak');
}

export async function endQuestion(): Promise<void> {
    return request<void>('EndQuestion');
}

export async function getQuestion(): Promise<Question> {
    return request<Question>('GetQuestion');
}

export async function getSampleQuestion(): Promise<Question> {
    return request<Question>('GetSampleQuestion');
}

export async function compileAndTest(code: string): Promise<CompileAndTestResult> {
    return request<CompileAndTestResult>('CompileAndTest', {
        code,
    });
}

export async function startChallenge(): Promise<void> {
    return request<void>('StartChallenge');
}

export async function submitSolution(id: number, code: string): Promise<void> {
    return request<void>('SubmitSolution', {
        id,
    });
}

export async function submitFeedback(feedback: string): Promise<boolean> {
    return request<boolean>('SubmitFeedback', {
        feedback,
    });
}
